import { VOImage } from "../../model/DataStructure.js";
import { AbstractImageItem } from "./AbstractImageItem.js";

export class AnimatedPixiImageItem extends AbstractImageItem<PIXI.Container> {

    private _apng: any = null;

    constructor(image: VOImage, screenWidth: number) {
        super(image, screenWidth);
    }

    protected createElement(image: VOImage): void {
        this.element = new PIXI.Container();

        const loader = new PIXI.Loader();
        var loadOptions: any = {
            loadType: PIXI.LoaderResource.LOAD_TYPE.XHR,
            xhrType: PIXI.LoaderResource.XHR_RESPONSE_TYPE.BUFFER,
            crossOrigin: ''
        };
        loader.add(image.image.url, loadOptions);
        loader.load((progress, resources) => {
            this._apng = new PixiApngAndGif(image.image.url, resources);
            var sprite = this._apng.sprite as PIXI.Sprite;
            var old = this.element;
            var index = old.parent.getChildIndex(old);
            var p = old.parent;
            old.parent.removeChild(old);
            p.addChildAt(sprite, index);
            sprite.x = old.x;
            sprite.y = old.y;
            sprite.visible = old.visible;

            this.element = sprite;
            old.destroy();
        });
    }

    protected setVisibility(visible: boolean): void {
        this.element.visible = visible;
        if (!this._apng)
            return;
        if (visible)
            this._apng.play();
        else
            this._apng.pause();
    }

    protected setTransform(x: number, y: number, scale: number): void {
        this.element.position.set(x, y);
        this.element.scale.set(scale);
    }
}